import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: {
        filters: [],
    },
    filters: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.loyalty_category.search.meta',
        );

        startLoading(dispatch, 'get-loyaltycategorymeta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-loyaltycategorymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-loyaltycategorymeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (
            !state.searchMeta ||
            !state.searchMeta.filters ||
            state.searchMeta.filters.length === 0
        ) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    async getRegionListIfNecessary({ commit }, { query }) {
        const response = await axios.get(
            Laroute.route('franchise.vue.regions'),
            {
                params: { query, limit: 1000 },
            },
        );
        return response.data.data.map(d => ({
            id: d.id,
            display_name: d.name,
        }));
    },

    async getTradingAreaListIfNecessary({ commit }, { query }) {
        const response = await axios.get(
            Laroute.route('franchise.vue.trading_area'),
            {
                params: { query, limit: 1000 },
            },
        );
        return response.data.data.map(d => ({
            id: d.id,
            display_name: d.name,
        }));
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/loyalty-category.js